module.exports = __webpack_public_path__ + "img/tp5.198e2803.png";